(() => {
  const selector = '.image-banner-wrapper .image-banner__media > img';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let ticking = false;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const update = () => {
    ticking = false;

    if (reducedMotion.matches) {
      document.querySelectorAll(selector).forEach((image) => {
        image.style.removeProperty('--bynour-parallax-y');
      });
      return;
    }

    const viewportHeight = window.innerHeight;

    document.querySelectorAll(selector).forEach((image) => {
      const banner = image.closest('.image-banner');
      if (!banner) return;

      const rect = banner.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
      const offset = clamp((progress - 0.5) * 220, -110, 110);
      image.style.setProperty('--bynour-parallax-y', `${offset.toFixed(2)}px`);
    });
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('shopify:section:load', requestUpdate);
  document.addEventListener('shopify:section:reorder', requestUpdate);
  reducedMotion.addEventListener?.('change', requestUpdate);

  requestUpdate();
})();
